/**
 * Checks if an object has a given field - this is different from Object.prototype.hasOwnProperty because
 * it checks if the field is on the object itself, not on the object's prototype
 *
 * Learn more - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyDescriptor
 */
export default function objectHasOwnField(value: unknown, field: string): boolean {
  if (value === null || value === undefined || typeof value !== "object") {
    return false;
  }

  return Object.getOwnPropertyDescriptor(value, field) !== undefined;
}
